/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1RequestStatus = {
    PendingPayment: 'pending_payment',
    Requested: 'requested',
    Accepted: 'accepted',
    Rejected: 'rejected',
    InProgress: 'in_progress',
    Delivered: 'delivered',
    Disputed: 'disputed',
    Completed: 'completed',
    Abandoned: 'abandoned',
    Refunded: 'refunded'
} as const
export type V1RequestStatus =
    (typeof V1RequestStatus)[keyof typeof V1RequestStatus]

export function instanceOfV1RequestStatus(value: any): boolean {
    for (const key in V1RequestStatus) {
        if (Object.prototype.hasOwnProperty.call(V1RequestStatus, key)) {
            if (
                V1RequestStatus[key as keyof typeof V1RequestStatus] === value
            ) {
                return true
            }
        }
    }
    return false
}

export function V1RequestStatusFromJSON(json: any): V1RequestStatus {
    return V1RequestStatusFromJSONTyped(json, false)
}

export function V1RequestStatusFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1RequestStatus {
    return json as V1RequestStatus
}

export function V1RequestStatusToJSON(value?: V1RequestStatus | null): any {
    return value as any
}

export function V1RequestStatusToJSONTyped(
    value: any,
    ignoreDiscriminator: boolean
): V1RequestStatus {
    return value as V1RequestStatus
}
